import React from 'react';
import { Link, NavLink } from 'react-router-dom';

function Footer() {
  return (
    <>
     <footer className="main-footer">
            <div className="footer-top">
                <div className="auto-container">
                    <div className="row clearfix">
                        
                          
                                <div className="col-lg-3 col-md-3 col-sm-12 footer-column">
                                    <div className="footer-widget logo-widget">
                                        <figure className="footer-logo"><a href="index.html"><img src="../annapurna/assets_web/images/logo.png" alt="" /></a></figure>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-12 footer-column">
                                    <div className="footer-widget links-widget">
                                        <div className="widget-title">
                                            <h3>Quick Links</h3>
                                        </div>
                                        <div className="widget-content">
                                            <ul className="links-list clearfix">
                                                <li><Link to={`/home`}>Home </Link></li>
                                                <li><Link to={`/about`}>About</Link></li>
                                                <li><Link to={`/whyannapurna`}>Why Annapurna</Link></li>
                                                <li><Link to={`/allproduct`}>Product</Link></li>
                                                <li><Link to={`/contact`}>Contact</Link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-12 footer-column">
                                    <div className="footer-widget links-widget">
                                        <div className="widget-title">
                                            <h3>Useful Links</h3>
                                        </div>
                                        <div className="widget-content">
                                            <ul className="links-list clearfix">
                                                <li><Link to="/privacy-policy">Privacy Policy </Link></li>
                                                <li><Link to="/terms-condition">Terms of Use</Link></li>
                                                <li><Link to="/shipping-returns">Shipping & Returns</Link></li>
                                                
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-12 footer-column">
                                    <div className="footer-widget contact-widget">
                                        <div className="widget-title">
                                            <h3>Contact</h3>
                                        </div>
                                        <ul className="info-list clearfix">
                                            <li>Plot No. 101, 11th Mile Stone,<br></br> Banda-Sagar Road, Chak-Rasoolpur Mod, Fatehpur, Uttar Pradesh, India </li>
                                            <li><a href="tel:23055873407">+91-9560823297</a></li>
                                            <li><a href="mailto:info@example.com">biofriend21@gmail.com</a></li>
                                        </ul>
                                       
                                    </div>
                                </div>
                            
                        
                        
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <div className="auto-container clearfix">
                    <ul className="cart-list pull-left clearfix">
                        <li><a href="index.html"><img src="assets_web/images/resource/card-1.png" alt="" /></a></li>
                        <li><a href="index.html"><img src="assets_web/images/resource/card-2.png" alt="" /></a></li>
                        <li><a href="index.html"><img src="assets_web/images/resource/card-3.png" alt="" /></a></li>
                        <li><a href="index.html"><img src="assets_web/images/resource/card-4.png" alt="" /></a></li>
                    </ul>
                    <div className="copyright pull-right">
                        <p>&copy; 2024 All Right Reserved</p>
                    </div>
                </div>
            </div>
        </footer>
        <button className="scroll-top scroll-to-target" data-target="html">
            <i className="fas fa-long-arrow-alt-up"></i>
        </button>
    
    </>
  )
}

export default Footer